import styled, { css } from "styled-components";
import { motion } from "framer-motion";

export const StyledAnimateFadeIn = styled(motion.div)`
  position: relative;
  z-index: 2;
  will-change: transform, opacity;
`;
